const state = {
  realtimeActive: false,
  userIds: new Set(),
  total: 0
};
export default state;
flarum.reg.add('fof-online-users-widget', 'common/onlineUsersState', state);